import classNames from 'classnames';
import { CurrencyFlagIcon } from 'components/shared/WithCountryFlag';
import { FC } from 'react';

export type CurrencyLabelProps = {
  currency: string;
  className?: string;
  onClick?: () => void;
  tabIndex?: number;
};

export const CurrencyLabel: FC<CurrencyLabelProps> = ({ currency, className, onClick, tabIndex }) => (
  <button type="button" onClick={onClick} className={classNames('btn btn-icon-start', className)} tabIndex={tabIndex}>
    <CurrencyFlagIcon currency={currency} className="icon" />
    {currency}
  </button>
);
